<template>
  <Collaborators
    scope-type="contract-manager"
    :scope-id="contractManagerId"
  />
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Collaborators from '@/domain/collaborators/components/Collaborators'

export default {
  name: 'UsersPageNew',
  components: { Collaborators },
  
  computed: {
    ...mapGetters('contractManager', [
      'contract_manager'
    ]),
    
    contractManagerId() {
      return this.$route.params.id
    }
  },
  
  async created() {
    // Carica i dati del contract manager se non sono già presenti
    // o se l'ID è diverso da quello corrente
    if (!this.contract_manager || this.contract_manager.id !== parseInt(this.contractManagerId)) {
      try {
        await this.fetchContractManager(this.contractManagerId)
      } catch (error) {
        console.error('Failed to load contract manager:', error)
      }
    }
  },
  
  methods: {
    ...mapActions('contractManager', [
      'fetchContractManager'
    ])
  }
}
</script>